import React from 'react';
import { connect } from 'react-redux';
import {
  Route,
  Redirect
} from 'react-router-dom';
import {
  authIsLoading,
  userIsLoggedIn
} from 'redux/User';

const PrivateRoute = ({
  component: Component,
  auth,
  authLoading,
  userLoggedIn,
  ...rest }) => {
  if (authLoading) return <div />;
  return (
    <Route
      {...rest}
      render={props =>
        userLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              search: props.location
                ? `?next=${props.location.pathname}${props.location.search}`
                : '',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default connect(state => ({
  location: state.router.location,
  authLoading: authIsLoading(state),
  userLoggedIn: userIsLoggedIn(state)
}))(PrivateRoute);
